import {Translate} from 'react-redux-i18n';
import {isEmpty} from 'front-onceforall-core/dist/utils/arrays';
import {Icon} from 'front-onceforall-core';
import {useCustomStore} from '../DepositorSectionStore';
import Document from './document';
import ExpandableList from '../../../../expandableList';
import {DOCUMENT_STATES_TO_PROCESS} from './utils/documentStatesToProcess';
import {useDossierCountry} from '../../../OrganisationDashboardContainer';
import {getDocumentsByCountry} from '../../../../../utils/document';
import {pathResolver} from '../../../../../utils/basePathHelper';

function DocumentsToProcessView() {
  const {state: {documents, loading}} = useCustomStore();
  const dossierCountry = useDossierCountry();

  const documentsToProcess = getDocumentsByCountry(documents, dossierCountry)
    .filter(document => document.overallStatusDocument)
    .filter(document => DOCUMENT_STATES_TO_PROCESS.includes(document.state))
    .map((document, index) => (
      <Document
        key={`document-to-process-${index}`}
        document={document}
      />
    ));

  return (
    <div className="mt-5">
      <h2 className="flex-container">
        <Translate value="dashboard.documentsToProcess.title"/>
        {loading && !isEmpty(documentsToProcess) && <Icon icon="loader"/>}
      </h2>
      <div>
        {isEmpty(documentsToProcess) &&
          <div
            className="card d-flex flex-column justify-content-center align-items-center font-size-m"
            style={{minHeight: 200}}
          >
            {loading ?
              <div className="loading-overlay"/> :
              <>
                <img
                  alt="validated"
                  src={pathResolver('resources/svg/checklist-validated.svg')}
                  height={70}
                  className="mb-4"
                />
                <Translate value="dashboard.documentsToProcess.emptyList"/>
              </>
            }
          </div>
        }
        <div className="card-container-notifications">
          <ExpandableList
            items={documentsToProcess}
            initialNumberOfItems={3}
            buttonLabel="dashboard.documentsToProcess.expandList"
          />
        </div>
      </div>
    </div>
  );
}

export default DocumentsToProcessView;
